const Footer = () => {
  return (
    <footer className="bg-gray-900 py-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center text-gray-400">
          <p>© {new Date().getFullYear()} Tushar Raj Choudhary. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 